import type { IControllerConstructor, IDirective, Injectable } from "angular";
import { module } from "angular";

import "./SvgDraggable.scss";
import SvgDraggablesDirectiveController from "./SvgDraggableDirectiveController";

export default class SvgDraggableDirective implements IDirective {
    public bindToController = {
        dragStart: "&dragStart",
        dragStop: "&dragStop",
        dragging: "&dragging",
        editable: "=?",
        position: "=?mmSvgDraggable",
        tap: "&tap",
    };

    public controller: Injectable<IControllerConstructor>;

    public controllerAs = "$ctrl";

    public restrict = "A";

    public scope = {};

    constructor() {
        this.controller = SvgDraggablesDirectiveController;
    }
}

module("mmGui").directive("mmSvgDraggable", () => new SvgDraggableDirective());
